import React from 'react'

import { useCurCluster, useCurOrg } from '~/hooks/state'
import { useRouteGuard } from '~/hooks/use-route-guard'
import { ClusterDeployType } from '~/utils/cluster-status'

const DeployTypeGuard: React.FC<
  React.PropsWithChildren<{ deployType: ClusterDeployType }>
> = ({ deployType, children }) => {
  const { curCluster } = useCurCluster()
  const { curOrg } = useCurOrg()

  useRouteGuard(
    curCluster?.deployType === deployType,
    `/orgs/${curOrg?.id}/clusters/${curCluster?.id}`
  )
  return <>{children}</>
}

export default DeployTypeGuard
